class DigitalNatureGridOverlayCellComponent extends HTMLElement
{
    constructor() {
        super();
    }
}

// add the custom element to the registry
customElements.define('digital-nature-grid-overlay-cell', DigitalNatureGridOverlayCellComponent);